import toast from 'react-hot-toast';
import { createApiClient } from '@pp/shared/api/createApiClient';
import { triggerLimitError } from '../contexts/limitHandler';

const apiClient = createApiClient({
  baseUrl: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  notify: {
    error: (message) => toast.error(message),
  },
  routes: {
    login: '/login',
    tenantNotFound: '/tenant-not-found',
    publicPaths: ['/login', '/forgot-password', '/reset-password', '/'],
    // Tenant-subdomain marketing landing — bouncing to /login here would
    // pull users off the page they intentionally browsed to. Same for the free
    // tools: they need no account, so a visitor with a stale session left over
    // from a trial must not be sent to sign in when its refresh fails.
    skipRedirectForPath: (pathname) =>
      pathname.startsWith('/service-areas/') || pathname === '/tools' || pathname.startsWith('/tools/'),
  },
  isPublicRegistrationRoute: () => {
    const path = window.location.pathname;
    return (
      path.startsWith('/register-isp') ||
      path === '/register/success' ||
      path === '/register/canceled'
    );
  },
  onLimitExceeded: (error) => triggerLimitError(error),
  onModuleNotIncluded: (error) => notifyModuleNotIncluded(error.module, error.message),
});

// One toast per module per minute: a page with several widgets from a gated
// module would otherwise stack identical messages.
const moduleToastShownAt = new Map<string, number>();
function notifyModuleNotIncluded(module: string, message: string) {
  const now = Date.now();
  const last = moduleToastShownAt.get(module) ?? 0;
  if (now - last < 60_000) return;
  moduleToastShownAt.set(module, now);
  toast.error(message, { id: `module-${module}` });
}

export default apiClient;

export {
  getErrorMessage,
  isHttpError,
  isValidationError,
  isNotFoundError,
  isForbiddenError,
  handleApiRequest,
} from '@pp/shared/api/errors';
